import { render, staticRenderFns } from "./TransactionItem.vue?vue&type=template&id=ec537f28&scoped=true&lang=pug&"
import script from "./TransactionItem.vue?vue&type=script&lang=js&"
export * from "./TransactionItem.vue?vue&type=script&lang=js&"
import style0 from "./TransactionItem.vue?vue&type=style&index=0&id=ec537f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec537f28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VDivider,VRow,VSpacer})
